// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"867":"3b551c213f363658","1283":"9342c78ce49f79aa","3578":"425efebfc692f61f","3874":"347f62c5a2277cb3"}[chunkId] + ".css";
};